import { FloorActionsList, FloorType } from "../actions/floorActions";
import { Action } from "../actions/types";

const initialValue: Array<FloorType> = []

export const FloorReducer = (state: FloorType[] = initialValue, action: Action) => {

    switch (action.type) {

        case FloorActionsList.ADD_FLOOR: {

            return [...state, action.data]
        }

        case FloorActionsList.EDIT_FLOOR: {

            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated
        }

        case FloorActionsList.FETCH_FLOOR: {

            return action.data

        }

        case FloorActionsList.DELETE_FLOOR: {
            return state.filter(i => i.id !== action.data.id)

        }

        default: return state
    }

}